// extracted by mini-css-extract-plugin
export default {"PanelContainer":"AdministracionNotificacionesInternas_PanelContainer__euy03"};